import InWallIcon from "../../assets/product-list-assets/wifi-InWall.svg";
import type { ProductListGroup } from "../../types";

export const wifiWall: ProductListGroup = {
  id: "wall",
  title: "productListGroup.wifiWall.title",
  icon: {
    src: InWallIcon,
    width: 16,
    height: 21,
  },
};
